module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_doctor16-839fd07923b33b40f9a2269339116936.png";